export default {
  TOGGLE_SECTION: 'toggleSection',
  OPEN_SECTION: 'openSection',
  CLOSE_SECTION: 'closeSection',
  DISPLAY_PANEL: 'displayPanel',
};
